import React, { useState } from "react";

export const ExcelPreview = ({ sheets, onChange }) => {
  const [active, setActive] = useState(0);
  if (!sheets || sheets.length === 0) {
    return (
      <p className="py-8 text-center text-sm text-slate-500">
        Nessun dato in anteprima.
      </p>
    );
  }

  const setCell = (r, c, value) => {
    const next = sheets.map((s) => ({ ...s, rows: s.rows.map((row) => [...row]) }));
    next[active].rows[r][c] = value;
    onChange(next);
  };

  const sheet = sheets[active];
  const maxCols = sheet.rows.reduce((m, r) => Math.max(m, r.length), 0);

  return (
    <div data-testid="excel-preview">
      {sheets.length > 1 && (
        <div className="mb-3 flex flex-wrap gap-2">
          {sheets.map((s, i) => (
            <button
              key={i}
              data-testid={`sheet-tab-${i}`}
              onClick={() => setActive(i)}
              className={`rounded-lg px-3 py-1.5 text-xs font-semibold transition-colors ${
                i === active
                  ? "bg-emerald-600 text-white"
                  : "bg-slate-100 text-slate-600 hover:bg-slate-200"
              }`}
            >
              {s.name || `Foglio ${i + 1}`}
            </button>
          ))}
        </div>
      )}
      <div className="max-h-[460px] overflow-auto rounded-xl border border-slate-200">
        <table className="w-full border-collapse text-sm">
          <tbody>
            {sheet.rows.map((row, r) => (
              <tr key={r} className={r === 0 ? "bg-emerald-50" : ""}>
                {Array.from({ length: maxCols }).map((_, c) => (
                  <td key={c} className="border border-slate-200 p-0">
                    <input
                      data-testid={`cell-${r}-${c}`}
                      value={row[c] ?? ""}
                      onChange={(e) => setCell(r, c, e.target.value)}
                      className={`w-full min-w-[110px] bg-transparent px-2 py-1.5 outline-none focus:bg-emerald-50 ${
                        r === 0 ? "font-bold text-slate-900" : "text-slate-700"
                      }`}
                    />
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <p className="mt-2 text-xs text-slate-400">
        Clicca su una cella per correggerla, poi scarica il file aggiornato.
      </p>
    </div>
  );
};
